import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { AppContext } from '@state/context'
import { useItemSettings } from '@hooks/useItemSettings'
import Menu from '@components/Menu'
import MenuItem from '@components/MenuItem'
import {
  resetFilters,
  setLevelFilter,
  setSchoolYearFilter,
  setSubjectFilter,
} from '@state/actions/filtersActions'
import { BUTTON_SIZE, BUTTON_TYPE, COLORS } from '@helpers/constants'
import Icon from '@components/Icon'
import Button from '@components/Button'
import { groupBy } from '@helpers/utilities'

const ContentFilter = (props) => {
  const {
    dark = false,
    alignPopups,
    filterActions,
    filterState,
  } = props
  const [state, dispatch] = useContext(AppContext)
  const { schoolYearFilter, subjectFilter, levelFilter, filteredItems } = filterState ?? state.filters
  const { schoolYears, subjects, levels } = useItemSettings()

  const availableSubjects = groupBy(filteredItems, 'subject', 'id')
  const availableLevels = groupBy(filteredItems, 'level', 'id')
  const availableSchoolYears = groupBy(filteredItems, 'schoolYear', 'id')

  const filters = [
    {
      selectedFilter: levelFilter,
      options: levels.filter((level) => availableLevels[level.id]),
      title: 'Nivå',
      action: filterActions?.setLevelFilter ?? setLevelFilter,
    },
    {
      selectedFilter: schoolYearFilter,
      options: schoolYears.filter((schoolYear) => availableSchoolYears[schoolYear.id]),
      title: 'Årskurs',
      action: filterActions?.setSchoolYearFilter ?? setSchoolYearFilter,
    },
    {
      selectedFilter: subjectFilter,
      options: subjects.filter((subject) => availableSubjects[subject.id]),
      title: 'Ämne',
      action: filterActions?.setSubjectFilter ?? setSubjectFilter,
    },
  ]

  return (
    <div className={'flex items-center'}>
      <Icon icon={'Filter'} color={dark ? COLORS.BLACK.TEXT : COLORS.WHITE.TEXT} />

      {filters.map(({ title, selectedFilter, options, action }) => (
        <Menu
          key={'filter-' + title}
          title={
            selectedFilter
              ? options?.find((option) => option.id === selectedFilter)?.name
              : title
          }
          boldTitle={!!selectedFilter}
          nowrap
          truncate
          dark={dark}
          align={alignPopups}
        >
          {options.map((option) => (
            <MenuItem
              key={title + '-option-' + option.id}
              onClick={() =>
                dispatch(
                  action(selectedFilter === option.id ? null : option.id)
                )
              }
              title={option.name}
              selected={selectedFilter === option.id}
            />
          ))}
        </Menu>
      ))}

      {filters.some(({ selectedFilter }) => selectedFilter) && (
        <>
          <div className='ml-4' />
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.ICON_CIRCLE}
            icon={'TrashCan'}
            handleClick={() => {
              dispatch(
                filterActions?.resetFilters
                  ? filterActions?.resetFilters()
                  : resetFilters()
              )
            }}
          />
        </>
      )}
    </div>
  )
}

ContentFilter.propTypes = {
  alignPopups: PropTypes.string
}

export default ContentFilter
